// extracted by mini-css-extract-plugin
export default {"root":"root___Urx8L","numbers":"numbers___ZK4Pf","button":"button___SUG3g","link":"link___HF6vk","active":"active___Wwn5a","prev":"prev___ApJ1N","next":"next___fVTsM"};